import isIterable from '~/src/lib/isIterable';
import { DateTime } from 'luxon';

/*
c1 => Visiteur inscrit ayant déjà commandé
c2 => Visiteur inscrit n’ayant jamais commandé
c3 => Visiteur inscrit et en attente de validation
c4 => Visiteur non inscrit
*/

const isDisplayMenu = (menu, user, lang = 'fr') => {
    //console.log('isDisplayMenu');
    //console.log(menu);
    //console.log(typeof menu.conditions);
    //console.log(user);
    //console.log(typeof menu.langs);

    if (typeof menu.start === 'string' && typeof menu.end === 'string') {
        const now = DateTime.now();
        const start = DateTime.fromSQL(menu.start);
        const end = DateTime.fromSQL(menu.end);
        if (now > start && now < end) {
            //return true;
        }
        return false;
    }

    if (
        isIterable(menu.restricted_users) === true &&
        menu.restricted_users.length > 0
    ) {
        if (typeof user?.uuid !== 'string') {
            return false;
        }

        if (!menu.restricted_users.includes(user?.uuid)) {
            return false;
        }
    }

    if (menu.conditions === null) {
        return true;
    }

    if (typeof menu.conditions !== 'object') {
        return true;
    }

    if (
        typeof menu.langs === 'object' &&
        isIterable(menu.langs) === true &&
        menu.langs.length > 0
    ) {
        if (menu.langs.includes(lang) === false) {
            return false;
        }
    }

    if (
        typeof menu.conditions.c1 === 'undefined' &&
        typeof menu.conditions.c2 === 'undefined' &&
        typeof menu.conditions.c3 === 'undefined' &&
        typeof menu.conditions.c4 === 'undefined'
    ) {
        return true;
    }

    if (
        menu.conditions.c1 &&
        user &&
        typeof user.orders === 'number' &&
        user.orders > 0
    ) {
        return true;
    }

    if (
        menu.conditions.c2 &&
        user &&
        typeof user.orders === 'number' &&
        user.orders === 0
    ) {
        return true;
    }

    if (menu.conditions.c3 && user && user.confirmed && user.confirmed === 1) {
        return true;
    }

    if (menu.conditions.c4 && user === false) {
        return true;
    }

    return false;
};

export default isDisplayMenu;
